// src/pages/AdminRevenue.jsx
import { useEffect, useState } from 'react';

export default function AdminRevenue() {
  const [revenue, setRevenue] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchRevenue() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/revenue`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (!res.ok) throw new Error('Kunne ikke hente inntjening');
        const data = await res.json();
        setRevenue(data);
      } catch (err) {
        console.error('❌ Henting feilet:', err);
        setError('Feil ved henting av inntektsdata');
      }
    }

    fetchRevenue();
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Inntekter per måned</h2>
      {error && <p className="text-red-500">{error}</p>}
      <ul className="space-y-2">
        {revenue.map((r, idx) => (
          <li key={idx}>
            <strong>{r.month}:</strong> {r.total.toFixed(2)} kr
          </li>
        ))}
      </ul>
    </div>
  );
}
